import React, { useRef, useEffect, useState } from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material"
import { Link } from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack" // Import back arrow icon
import plan from "../plan.json"
// import planB from "../planB.json"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange"
import RevenueComparison from "../components/RevenueComparison"
import RevenuePercentageComparison from "../components/RevenuePercentageComparison"
import AmusementPieChart from "../components/AmusementPieChart"
import RateTaxPlanModal from "../components/RateTaxPlanModal"
import YouTube from "react-youtube" // Import YouTube component
import StarBorderPurple500Icon from "@mui/icons-material/StarBorderPurple500"
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo"
import { Helmet } from "react-helmet"

function createData(revenueStream, currentTax, newTax, amusement) {
  return { revenueStream, currentTax, newTax, amusement }
}

const rows = [
  createData("5% Admissions Fee (Example)", "$1,750,000", "$1,750,000", "N/A"),
  createData("Sales Tax for Schools", "N/A", "$735,000", "$735,000"),
  createData("Carbon Emissions Tax", "N/A", "$210,600", "$210,600"),
  createData("Naming Rights Tax", "N/A", "$350,000", "$350,000"),
  createData("10% Amusement Tax", "N/A", "N/A", "$3,500,000"),
  createData("Property Tax Equivalent", "N/A", "N/A", "$1,400,000"),
  createData("Total Annual Revenue", "$1,750,000", "$3,045,100", "$6,195,000"),
]

const headerCell = {
  fontWeight: "bold", // Bold text
  backgroundColor: "#f5f5f5", // Light grey background
}

const Plan = () => {
  const [open, setOpen] = useState(false)
  const [showVideo, setShowVideo] = useState(false) // New state for showing video

  const tableRef = useRef(null)

  useEffect(() => {
    const isSmallScreen = window.innerWidth <= 600 // Define your mobile breakpoint
    if (isSmallScreen && tableRef.current) {
      const scrollAmount = tableRef.current.scrollWidth * 1 // Scroll to 100% of the table width
      tableRef.current.scrollLeft = scrollAmount
    }
  }, [])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        padding: "2rem",
        gap: "2rem",
      }}
    >
      <Helmet>
        <title>Equitable Revenue Enhancement Plan</title>
      </Helmet>
      {/* Floating Back Button */}
      <Link to="/plan" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ArrowBackIcon />}
          sx={{
            position: "fixed",
            top: "16px",
            left: "16px",
            zIndex: 1000, // Ensure it floats above other content
          }}
        >
          Back
        </Button>
      </Link>
      <a
        href="./assets/Equitable_Revenue_Enhancement_Plan.pdf"
        download={"Equitable_Revenue_Enhancement_Plan"}
        target="_blank"
      >
        <Button
          endIcon={<CurrencyExchangeIcon />}
          variant="contained"
          color="success"
        >
          Download the full Plan here
        </Button>
      </a>
      {/* Button to open the modal */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpen()
        }}
        startIcon={<StarBorderPurple500Icon />}
      >
        Rate the Plan
      </Button>
      {/* adding comments */}
      <RateTaxPlanModal
        open={open}
        plan={"plan"}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      {!showVideo && (
        <Button
          variant="contained"
          color="error"
          onClick={() => setShowVideo(true)}
          sx={{
            width: { xs: "60%", sm: "30%" },
            fontWeight: 900,
            height: "100px",
          }}
        >
          <OndemandVideoIcon fontSize="large" />
        </Button>
      )}

      {/* YouTube video iframe */}
      {showVideo && (
        <Box width={{ xs: "100%", md: "60%" }}>
          <YouTube
            style={{ flexGrow: "1" }}
            videoId="3aIDuII7NUY"
            opts={{
              width: "100%",
              playerVars: {
                autoplay: 1,
                cc_load_policy: 1,
              },
            }}
          />
        </Box>
      )}
      <Typography
        textAlign={"center"}
        fontSize={"36px"}
        sx={{
          textShadow: "1px 1px 1px rgba(0,0,0,0.5)",
          fontWeight: 600,
          backgroundColor: "#84A586",
          borderRadius: "15px",
          padding: "12px",
        }}
      >
        Equitable Revenue Enhancement Plan: A Tiered Tax Structure for
        Large-Scale Entities in Southeast Highland Park
      </Typography>
      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          gap: ".875rem",
        }}
      >
        <Box
          sx={{
            border: "2px black solid",
            borderRadius: "15px",
            padding: "1rem",
          }}
        >
          <Typography
            sx={{ fontSize: "24px", fontWeight: 600, textAlign: "center" }}
          >
            Objective:
          </Typography>
          <Typography>{plan.objective}</Typography>
        </Box>
        {/* Button to watch the video */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        ></Box>
        <Box>
          {plan.sections.map((section, index) => (
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.5rem",

                    color: "black",
                  }}
                >
                  {section.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>{section.description}</AccordionDetails>
              {section.description2 && (
                <AccordionDetails>{section.description2}</AccordionDetails>
              )}
              <AccordionDetails>
                {section.calculationDescription}
              </AccordionDetails>
              <AccordionDetails>
                {section.calculation}
                <span style={{ fontWeight: 900 }}>{section.totalRevenue}</span>
              </AccordionDetails>
              {section.calculationDescription2 && (
                <>
                  <AccordionDetails>
                    {section.calculationDescription2}
                  </AccordionDetails>
                  <AccordionDetails>
                    {section.calculation2}
                    <span style={{ fontWeight: 900 }}>
                      {section.totalRevenue2}
                    </span>
                  </AccordionDetails>
                </>
              )}
              {index === plan.sections.length - 1 && (
                <AccordionDetails>
                  <AmusementPieChart /> {/* Render the Pie Chart */}
                </AccordionDetails>
              )}
            </Accordion>
          ))}
        </Box>
      </Box>
      <Box textAlign={"center"}>
        <Typography fontWeight={900} fontSize={24}>
          Side-by-Side Comparison of Revenue
        </Typography>
        <Typography fontSize={12}>
          **Using Ravinia Festival as ONLY an example**
        </Typography>
        <Typography fontSize={12}>
          **Based off an average of $35,000,000 in annual revenue as only an
          example**
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.3)", // Thicker shadow
          borderRadius: "12px", // Optional: To give it rounded corners
          // padding: "1rem", // Optional: Adds padding around the table
          overflowX: "auto",
          width: "100vw",
        }}
        ref={tableRef}
      >
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ ...headerCell, position: "sticky", top: 0, left: 0 }}
              >
                Revenue Stream
              </TableCell>
              <TableCell sx={headerCell} align="right">
                Current (Before New Plan)
              </TableCell>
              <TableCell sx={headerCell} align="right">
                Immediate Taxes (Before Agreement Expiration)
              </TableCell>
              <TableCell sx={headerCell} align="right">
                Amusement Tax (After Agreement Expiration)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={row.revenueStream}
                sx={{
                  "&:last-child td": {
                    fontWeight: 900, // black text for the last row
                    fontSize: "18px", // 16px font size for the last row
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "white", // Add a background color to avoid transparency
                    zIndex: 1, // Ensures the header is above the other cells
                    ...headerCell,
                    ...(index >= 0 &&
                      index < rows.length - 1 && {
                        fontSize: "14px",
                        fontWeight: 400,
                      }),
                    ...(index === rows.length - 1 && { fontSize: "18px" }),
                  }}
                >
                  {row.revenueStream}
                </TableCell>
                <TableCell align="right">{row.currentTax}</TableCell>
                <TableCell align="right">{row.newTax}</TableCell>
                <TableCell align="right">{row.amusement}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <RevenueComparison />
      <RevenuePercentageComparison />

      <Typography fontWeight={900} fontSize={24}>
        Conclusion
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          paddingX: "1.5rem",
          gap: "1rem",
        }}
      >
        <Typography>{plan.conclusion}</Typography>
        <Typography>{plan.conclusion2}</Typography>
      </Box>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Rate the Plan
      </Button>
      <a
        href="./assets/Equitable_Revenue_Enhancement_Plan.pdf"
        download={"Equitable_Revenue_Enhancement_Plan"}
        target="_blank"
      >
        <Button
          endIcon={<CurrencyExchangeIcon />}
          variant="contained"
          color="success"
        >
          Download the Plan!
        </Button>
      </a>
    </Box>
  )
}

export default Plan
